module.exports = __webpack_public_path__ + "img/am01.2220462e.jpg";